var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group input-group-outline input-add",class:{'my-input-disabled': _vm.isBlocked === true }},[_c('input',{ref:"namedInput",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.named},on:{"focus":_vm.selectContent,"input":_vm.handleInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }